import { render, staticRenderFns } from "./InquiryPage.vue?vue&type=template&id=66f75157&"
import script from "./InquiryPage.vue?vue&type=script&lang=js&"
export * from "./InquiryPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports